const animate = (start, end, duration, easing, cb) => {
  return new Promise((resolve, reject) => {
    const begin = Date.now();
    const update = () => {
      const now = Date.now();
      const t = (now - begin) / duration;
      const v = easing(t);
      const v2 = start + v * (end - start);
      cb(v2);
      if (t < 1) {
        requestAnimationFrame(update);
      } else {
        resolve();
      }
    };
    requestAnimationFrame(update);
  });
}

export default animate;



// WEBPACK FOOTER //
// ./src/utils/animate.js